import router from './router'

export default {
	moduleName: 'ipBlockList',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/ipBlockList/index.js